module.exports = __webpack_public_path__ + "static/media/bino.34d491eb.svg";